var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.place.location)?_c('GmapMarker',{attrs:{"position":_vm.position}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }